const interval = setInterval(() => {
  const liveChatLink = document.querySelector('a[href="#livechat"]');
  const shopifyChat = document.querySelector('#shopify-chat');

  if (!shopifyChat) return; // Keep waiting until it exists

  console.log("shopifyChat---", shopifyChat);

  // Once found, stop the interval
  clearInterval(interval);

  // Function to check shadow DOM for the class
  function checkChatOpen() {
    const shadowHost = shopifyChat.querySelector('inbox-online-store-chat');
    if (!shadowHost) return;

    

    const shadowRoot = shadowHost.shadowRoot;
    if (!shadowRoot) return;
    const chatApp = shadowRoot.querySelector('.chat-app--is-open');
    if (chatApp) {
      shopifyChat.style.display = 'block';
    } else {
      shopifyChat.style.display = 'none';
    }
  }

  // Initially hide and then check
  shopifyChat.style.display = 'none';
  checkChatOpen();



  // Observe DOM changes to update display dynamically
  const observer = new MutationObserver(checkChatOpen);
  observer.observe(document.body, { childList: true, subtree: true });

  // Live chat link click handler
  if (liveChatLink) {
    liveChatLink.addEventListener('click', function (event) {
      event.preventDefault();

      const chatComponent = document.querySelector('inbox-online-store-chat');
      if (chatComponent && chatComponent.shadowRoot) {
        const chatButton = chatComponent.shadowRoot.querySelector('[data-spec="toggle-button"]');
        if (chatButton) {
          chatButton.click();
          shopifyChat.style.display = 'block';
          const shopifyChat_main = document.querySelector('#shopify-chat');
          if(shopifyChat_main) {
            const shadowHost = shopifyChat_main.querySelector('inbox-online-store-chat');
            const close_button = shadowHost.shadowRoot.querySelector('button[name="closeChat"]');
  
            console.log("close_button0-00-0", close_button);
            if(close_button) {
              close_button.addEventListener('click', function (event) {
                checkChatOpen();
              });
            }
          }

        } else {
          console.warn('Chat toggle button not found inside shadow root.');
        }
      } else {
        console.warn('Chat component or its shadow root not found.');
      }
    });
  }

}, 200); // Check every 200ms until #shopify-chat exists
